var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsRoute53Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABHVBMVEX7+/v09PT5+fny8vL0 9fX5+vv5+fr19fX5+Pj09fb07ej2wpz02sf59PD06+X3yaf2vZT57+j08vH559v2w5/5+fj2u5H1 hTX1jUP2n2D1mVj1hzn1hTb2m1n2pm72lE72t4r59vT3za/1iTv1hTT1hDT1gzL1hDP1iTz107v0 9PX1yan1hzj2k0355dj2mVf2r3z08e71omb1s4P09vf55NX2kUj1mFb059/1uIz3wZv19fb08e/1 o2n2pWz5+Pf1rnv1gzH2sH709PP19vf42cP2j0X1kUv02MT19PT428b1rXr1l1T1jUL1hjb2n2H2 uY303c34+Pj59/f06uP549P1zLD2qXL3vJL58+/5+/z07+v459v09vb///9iNl33AAAAAWJLR0Re BNZhuwAAAAd0SU1FB+YJGQwJI1Z3GwQAAADwSURBVCjPY2BgZMIGmXGIMzIx4BBnRNHBAsXIOlhY WdjYOTiZONlYOJB0sHFx8/Dy8QsICgmLCHKKInQIiYlLSEpJy8jKyYsrKLLAdXAqKauoqqmLi6ur qatoaLLCdGixauuIw4Cqrh4nQoegvjpMQs0A2VWGRmpwCWM2hKtMTM1UYRLq5hZsMB0sTJZwk8TF Vays4TpsbNUQEmp2YPeCddg7OCIkHJ2c4TpcXN0c1VXA5qipuXuwIlzl6eXt4+unrq7u6x8QGMSC FLouwSGhYeG6EYGRnKwsqKHLZhIVHePJyoI1PmJJjkHi4pwZhzgAen8f37Lk1RQAAAAldEVYdGRh dGU6Y3JlYXRlADIwMjItMDktMjVUMTI6MDk6MzQrMDA6MDApbCN5AAAAJXRFWHRkYXRlOm1vZGlm eQAyMDIyLTA5LTI1VDEyOjA5OjM0KzAwOjAwWDGbxQAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAy Mi0wOS0yNVQxMjowOTozNSswMDowMKlTsa4AAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsRoute53Svg);
export default __webpack_public_path__ + "static/media/aws_route_53_svg.7e0b2efbd7e9e237226827df05206dc4.svg";
export { ForwardRef as ReactComponent };